module.exports = { "default": require("core-js/library/fn/number/is-safe-integer"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-json-tree/~/babel-runtime/core-js/number/is-safe-integer.js
// module id = 1484
// module chunks = 0